<template>
  <main>
    <section class="container-lil flex flex-col align-items-center">

      <h1 class="secondary-font text-5xl text-center mt-5 mb-7">
        Discuter avec <br/>un conseiller client
      </h1>

      <div class="flex-center flex-wrap">
        <div v-for="agent in CHAT_AGENTS" :key="agent.name" class="flex flex-col align-items-center mx-2 my-2">
          <img :src="agent.avatar" class="size-3xl rounded-100" :alt="agent.name" />
          <span class="text-sm text-grey-600 mt-1">{{ agent.name }}</span>
        </div>
      </div>

      <a :href="`tel:${phoneNumberClean}`">
        <h1 class="text-4xl secondary-font text-grey-800 my-8">
          {{ phoneNumber }}
        </h1>
      </a>

      <a :href="`tel:${phoneNumberClean}`">
        <button class="btn lg btn-chatbot flex-center px-10 gap-2">
          <img src="/public/icons/icon-aide-appel.svg" class="btn-icon" alt="" />
          <span>Appelez maintenant</span>
        </button>
      </a>

      <div class="clear-both h-70"></div>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import communicationService from '@/services/communicationService'
import { CHAT_AGENTS } from '@/constants/chatAgents'

export default defineComponent({
  name: 'ServiceClientView',
  setup() {
    const config = communicationService.getConfig()
    const phoneNumber = config.phoneNumber || '+225 21 55 33 66 22'

    const phoneNumberClean = computed(() => {
      return phoneNumber.replace(/\s/g, '')
    })

    return {
      phoneNumber,
      phoneNumberClean,
      CHAT_AGENTS
    }
  }
})
</script>

<style scoped>
/* Les styles globaux sont déjà définis dans les fichiers CSS globaux */
</style>

